/* EF Universal PDP — variant picker + qty + ATC + express checkout
   Phase 4.3 (2026-05-04). State management for cards/pills/swatches/dropdowns.
   Reads variants from <script id="efUniVariantsData"> embedded in template. */
(function () {
  'use strict';

  function init() {
    var form = document.getElementById('efUniForm');
    if (!form) return;

    var variantsData;
    try {
      variantsData = JSON.parse(document.getElementById('efUniVariantsData').textContent);
    } catch (e) {
      console.warn('[ef-uni-pdp] variants data parse failed', e);
      return;
    }

    var variantIdInput = document.getElementById('efUniVariantId');
    var atcBtn         = document.getElementById('efUniATC');
    var atcText        = atcBtn ? atcBtn.querySelector('[data-atc-text]') : null;
    var priceCurrent   = document.getElementById('efUniPriceCurrent');
    var priceCompare   = document.getElementById('efUniPriceCompare');
    var priceSave      = document.getElementById('efUniPriceSave');
    var priceFrom      = document.getElementById('efUniPriceFrom');
    var express        = document.getElementById('efUniExpressCheckout');

    /* Build state: {axisPosition: selectedValue} */
    var state = {};
    document.querySelectorAll('.ef-uni-variant-group').forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-axis'), 10);
      var sel = group.querySelector('.is-active, [aria-checked="true"]')
             || group.querySelector('[data-variant-option]')
             || group.querySelector('.ef-uni-variant-select');
      if (!sel) return;
      state[pos] = sel.dataset.variantOption || sel.value;
    });

    /* If product has no option groups (single variant), state stays {} and
       we just track first variant. */
    if (!Object.keys(state).length && variantsData.length) {
      state[1] = variantsData[0].option1;
    }

    function findMatchingVariant() {
      return variantsData.find(function (v) {
        return (!state[1] || v.option1 === state[1])
            && (!state[2] || v.option2 === state[2])
            && (!state[3] || v.option3 === state[3]);
      });
    }

    function fmtPrice(cents) {
      var amount = (cents / 100);
      var hasFrac = amount % 1 !== 0;
      var formatted = amount.toLocaleString('en-US', hasFrac ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : {});
      return '$' + formatted;
    }

    /* Grill hood/finish changes use the exact native variant media, including URL entry. */
    var galleryVariantId = null;
    var gallerySyncToken = 0;
    function syncGrillMedia(v, userSelection) {
      var firepitMedia = form.hasAttribute('data-ef-firepit-media');
      if ((!form.hasAttribute('data-ef-grill-media') && !firepitMedia) || galleryVariantId === v.id || (firepitMedia && !userSelection)) return;
      galleryVariantId = v.id;
      var token = ++gallerySyncToken;
      var media = v.featured_media || v.featured_image;
      var position = media && Number(media.position);
      if (!position || position < 1) return;
      var attempts = 0;
      function apply() {
        if (token !== gallerySyncToken) return;
        var gallery = window.EFGallery && window.EFGallery.main;
        if (gallery && !gallery.destroyed && gallery.slides && gallery.slides.length >= position) {
          gallery.slideTo(position - 1, 0);
        } else if (++attempts < 60) {
          window.setTimeout(apply, 100);
        }
      }
      apply();
    }

    function updateUI(userSelection) {
      var v = findMatchingVariant();

      /* Update group label "selected" display */
      document.querySelectorAll('.ef-uni-variant-group').forEach(function (group) {
        var pos = parseInt(group.getAttribute('data-axis'), 10);
        var disp = group.querySelector('[data-selected-display]');
        if (disp && state[pos]) disp.textContent = state[pos];
      });

      /* Active state on cards/pills/swatches + per-axis info box */
      var axisActiveDesc = {};
      document.querySelectorAll('[data-variant-option]').forEach(function (el) {
        var pos = parseInt(el.dataset.axisPosition, 10);
        var match = state[pos] === el.dataset.variantOption;
        el.classList.toggle('is-active', match);
        el.setAttribute('aria-checked', match ? 'true' : 'false');
        if (match && el.dataset.infoDesc) axisActiveDesc[pos] = el.dataset.infoDesc;
      });
      /* Show description for currently active option (per axis) */
      document.querySelectorAll('[data-axis-info-for]').forEach(function (info) {
        var pos = parseInt(info.dataset.axisInfoFor, 10);
        var desc = axisActiveDesc[pos];
        if (desc) { info.textContent = desc; info.hidden = false; }
        else { info.textContent = ''; info.hidden = true; }
      });

      /* Pill price labels — "Included" for cheapest in this option (with current other selections),
         "+$X" for upcharge over cheapest. Matches Woodland Direct UX. */
      // Build per-axis: { pos → { val → price assuming other axes match state } }
      var probePrices = {};
      document.querySelectorAll('.ef-uni-variant-pill, .ef-uni-variant-card').forEach(function (pill) {
        var pos = parseInt(pill.dataset.axisPosition, 10);
        var val = pill.dataset.variantOption;
        if (!probePrices[pos]) probePrices[pos] = {};
        var probeState = Object.assign({}, state);
        probeState[pos] = val;
        var probeVar = variantsData.find(function (vv) {
          return (!probeState[1] || vv.option1 === probeState[1])
              && (!probeState[2] || vv.option2 === probeState[2])
              && (!probeState[3] || vv.option3 === probeState[3]);
        });
        probePrices[pos][val] = probeVar ? probeVar.price : null;
      });
      // For each axis, find min price (= base for that axis)
      var axisMin = {};
      Object.keys(probePrices).forEach(function (pos) {
        var prices = Object.values(probePrices[pos]).filter(function (p) { return p != null; });
        axisMin[pos] = prices.length ? Math.min.apply(null, prices) : null;
      });
      // Render delta per pill
      document.querySelectorAll('.ef-uni-variant-pill, .ef-uni-variant-card').forEach(function (pill) {
        var deltaEl = pill.querySelector('[data-price-delta]');
        if (!deltaEl) return;
        var pos = parseInt(pill.dataset.axisPosition, 10);
        var val = pill.dataset.variantOption;
        var price = probePrices[pos][val];
        var min = axisMin[pos];
        if (price == null || min == null) { deltaEl.textContent = ''; return; }
        if (price === min) {
          deltaEl.textContent = 'Included';
          deltaEl.classList.add('is-included');
        } else {
          deltaEl.textContent = '+' + fmtPrice(price - min);
          deltaEl.classList.remove('is-included');
        }
      });

      if (!v) {
        if (atcText) atcText.textContent = 'Unavailable';
        if (atcBtn) atcBtn.disabled = true;
        if (express) express.disabled = true;
        return;
      }

      syncGrillMedia(v, userSelection);

      /* Update form variant id */
      if (variantIdInput) variantIdInput.value = v.id;

      /* Update price + compare + save (dynamic per variant) */
      if (priceCurrent) priceCurrent.textContent = fmtPrice(v.price);
      if (priceCompare) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceCompare.textContent = fmtPrice(v.compare_at_price);
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }
      if (priceSave) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceSave.textContent = 'Save ' + fmtPrice(v.compare_at_price - v.price);
          priceSave.hidden = false;
        } else {
          priceSave.hidden = true;
        }
      }
      /* Gallery "Save $X" badge — keep in sync with the selected size (was static,
         showing the largest size's MSRP minus the cheapest price). */
      var saveBadgeWrap = document.getElementById('efUniSaveBadgeWrap');
      var saveBadgeAmt  = document.getElementById('efUniSaveBadgeAmt');
      if (saveBadgeWrap) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          if (saveBadgeAmt) saveBadgeAmt.textContent = fmtPrice(v.compare_at_price - v.price);
          saveBadgeWrap.style.display = 'flex';
        } else {
          saveBadgeWrap.style.display = 'none';
        }
      }
      if (priceFrom) {
        /* Hide "From" once a specific variant is selected and no other axis varies */
        priceFrom.hidden = true;
      }

      /* Update ATC text */
      if (atcText) {
        atcText.textContent = v.available
          ? 'Add to Cart — ' + fmtPrice(v.price)
          : 'Sold Out';
      }
      if (atcBtn) atcBtn.disabled = !v.available;
      if (express) express.disabled = !v.available;

      /* Update URL with ?variant=<id> */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* Click handler — cards / pills / swatches / custom dropdown options */
    form.addEventListener('click', function (e) {
      /* Custom dropdown trigger toggle */
      var trigger = e.target.closest('.ef-uni-dropdown__trigger');
      if (trigger) {
        e.preventDefault();
        var dd = trigger.closest('.ef-uni-dropdown');
        var open = dd.getAttribute('data-open') === 'true';
        /* Close all other dropdowns */
        form.querySelectorAll('.ef-uni-dropdown[data-open="true"]').forEach(function (other) {
          other.setAttribute('data-open', 'false');
          other.querySelector('.ef-uni-dropdown__trigger').setAttribute('aria-expanded', 'false');
        });
        dd.setAttribute('data-open', open ? 'false' : 'true');
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        return;
      }
      var target = e.target.closest('[data-variant-option]');
      if (!target) return;
      e.preventDefault();
      var pos = parseInt(target.dataset.axisPosition, 10);
      state[pos] = target.dataset.variantOption;

      /* If the click came from a custom dropdown option, sync trigger + close menu */
      var ddOption = target.closest('.ef-uni-dropdown__option');
      if (ddOption) {
        var dd = target.closest('.ef-uni-dropdown');
        if (dd) {
          var trig = dd.querySelector('.ef-uni-dropdown__trigger');
          var trigLabel = trig.querySelector('.ef-uni-dropdown__trigger-label');
          if (trigLabel) trigLabel.textContent = target.dataset.variantOption;
          dd.setAttribute('data-open', 'false');
          trig.setAttribute('aria-expanded', 'false');
          /* Sync hidden select for form submit */
          var sel = dd.querySelector('.ef-uni-variant-select');
          if (sel) sel.value = target.dataset.variantOption;
          /* Update aria-selected on options */
          dd.querySelectorAll('.ef-uni-dropdown__option').forEach(function (o) {
            var on = o.dataset.variantOption === target.dataset.variantOption;
            o.classList.toggle('is-active', on);
            if (o.parentElement) o.parentElement.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        }
      }

      updateUI(true);

      /* After updateUI, refresh the dropdown trigger price for axis that own a dropdown */
      var v = findMatchingVariant();
      if (v && ddOption) {
        var ddTriggerPrice = target.closest('.ef-uni-dropdown')?.querySelector('.ef-uni-dropdown__trigger-price');
        if (ddTriggerPrice) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            ddTriggerPrice.innerHTML = '<s style="color:#8A8579;font-weight:400;margin-right:5px">' + fmtPrice(v.compare_at_price) + '</s>' + fmtPrice(v.price);
          } else {
            ddTriggerPrice.textContent = fmtPrice(v.price);
          }
        }
      }

      /* Sync gallery to variant media when available (color swatches mainly) */
      if (!form.hasAttribute('data-ef-grill-media') && target.dataset.mediaIndex !== undefined && window.EFGallery && window.EFGallery.main) {
        var idx = parseInt(target.dataset.mediaIndex, 10);
        if (!isNaN(idx) && idx >= 0) {
          try { window.EFGallery.main.slideTo(idx); } catch (err) {}
        }
      }
    });

    /* Close custom dropdowns on outside click */
    document.addEventListener('click', function (e) {
      if (e.target.closest('.ef-uni-dropdown')) return;
      form.querySelectorAll('.ef-uni-dropdown[data-open="true"]').forEach(function (dd) {
        dd.setAttribute('data-open', 'false');
        dd.querySelector('.ef-uni-dropdown__trigger').setAttribute('aria-expanded', 'false');
      });
    });

    /* Change handler — dropdowns */
    form.addEventListener('change', function (e) {
      var sel = e.target.closest('.ef-uni-variant-select');
      if (!sel) return;
      var pos = parseInt(sel.dataset.axisPosition, 10);
      state[pos] = sel.value;
      updateUI(true);
    });

    /* Quantity stepper */
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      e.preventDefault();
      var input = form.querySelector('.ef-uni-qty__input');
      if (!input) return;
      var delta = parseInt(btn.dataset.qty, 10);
      var current = parseInt(input.value, 10) || 1;
      var next = Math.max(1, Math.min(99, current + delta));
      input.value = next;
    });

    /* Express Checkout — silent ATC + redirect to /checkout */
    if (express) {
      express.addEventListener('click', function (e) {
        if (express.disabled) return;
        e.preventDefault();
        var v = findMatchingVariant();
        if (!v || !v.available) return;
        express.disabled = true;
        express.style.opacity = '0.6';
        var qtyInput = form.querySelector('.ef-uni-qty__input');
        var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
        })
        .then(function (r) { if (!r.ok) throw new Error('cart-add-failed'); return r.json(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) {
          console.error('[ef-uni-pdp] express checkout failed', err);
          express.disabled = false;
          express.style.opacity = '';
          alert('Could not start checkout. Please use Add to Cart instead.');
        });
      });
    }

    /* Restore state from URL ?variant=ID on load */
    var urlVariant = new URL(window.location.href).searchParams.get('variant');
    if (urlVariant) {
      var v = variantsData.find(function (vv) { return String(vv.id) === urlVariant; });
      if (v) {
        if (v.option1) state[1] = v.option1;
        if (v.option2) state[2] = v.option2;
        if (v.option3) state[3] = v.option3;
      }
    }

    updateUI();
  }

  /* Accordion uses native <details>/<summary> — no JS needed. */

  /* ════ Finish-image fallback for swatches without variant image ════
     Liquid renders swatch chip with hex bg when variant lacks featured_media.
     This pass replaces those with finish images from window.EF_FINISH_IMAGES
     (extracted from the customizer's ef-cfg-images.js). 11/12 mantel finishes,
     plus 100+ door/screen finishes — applies to any product on universal PDP. */
  function applyFinishImages() {
    var map = window.EF_FINISH_IMAGES;
    if (!map) return;
    var swatches = document.querySelectorAll('.ef-uni-variant-swatch:not(.ef-uni-variant-swatch--img)');
    swatches.forEach(function (sw) {
      var name = (sw.getAttribute('aria-label') || '').trim().toLowerCase();
      if (!name) return;
      var url = map[name];
      if (!url) return;
      var chip = sw.querySelector('.ef-uni-variant-swatch__chip');
      if (!chip) return;
      chip.style.background = '';
      chip.style.backgroundImage = 'url(' + url + ')';
      chip.style.backgroundSize = 'cover';
      chip.style.backgroundPosition = 'center';
      sw.classList.add('ef-uni-variant-swatch--img');
    });
  }

  /* ════ Phase 5.1 — Mobile FAB auto-hide when expert card in viewport ════ */
  function initFab() {
    var fab = document.getElementById('efUniFab');
    var expert = document.querySelector('.ef-uni-expert');
    if (!fab || !expert) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        fab.classList.toggle('is-hidden', e.isIntersecting);
      });
    }, { threshold: 0.4 });
    io.observe(expert);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initFab(); applyFinishImages(); });
  } else {
    init();
    initFab();
    applyFinishImages();
  }
})();
